import { React, useEffect, useState } from "react";
import CustomInput from "../components/CustomInput";
import ReactQuill from "react-quill";
import { useLocation, useNavigate } from "react-router-dom";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
 import Dropzone from "react-dropzone";
import { uploadImg, uploadVideo, delImg, deleteVideo, uploadDescImg, delDescImg, deleteDescVideo, uploadDescVideo } from "../features/upload/uploadSlice";
import { createProducts, getAProduct, resetState, updateAProduct } from "../features/product/productSlice";
import { getBrands } from "../features/brand/brandSlice";
import { getSizes } from "../features/size/sizeSlice";
import { Select } from "antd";
import { getBrandModels } from "../features/brandModel/brandModelSlice";
  
let schema = yup.object().shape({
  title: yup.string().required("Title is Required"),
  description: yup.string().required("Description is Required"),
   price: yup.number().required("Price is Required"),
  brand: yup.string().required("Brand is Required"),
  brandModel: yup.string().required("Brand Model is Required"),
  type: yup.string().required("Type is Required"),
  yom: yup.string().required("Year of Manufacture is Required"),
  tags: yup.string().required("Tag is Required"),
  drive: yup.string().required("Drive is Required"),
  mileageCategory: yup.string().required("Mileage Category is Required"),
  horsePower: yup.number().required("Horse Power is Required"),
  acceleration: yup.number().required("Acceleration is Required"),
  fuelType: yup.string().required("Fuel Type is Required"),
  transmission: yup.string().required("Transmission is Required"),
  engineSize: yup.array().required("Engine is Required"),
  location: yup.string().required("Location is Required"),
  availability: yup.string().required("Availability is Required"),
 
   market: yup.string() ,
  seats: yup.string() ,
  seatsNumber: yup.string() ,
   engineDetail: yup.string() ,
  torque: yup.string() ,
  driveTrain: yup.string() ,
  rearSeats: yup.string() ,
  upholstery: yup.string() ,
  cargoSpace: yup.string() ,
  frontSeats: yup.string() ,
  steeringWheel: yup.string() ,
  climateControl: yup.string() ,
  fuelEfficiency: yup.string() ,
  towingCapacity: yup.string() ,
  groundClearance: yup.string() ,
  interiorLighting: yup.string(),  
 });


const Addproduct = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

  useEffect(() => {
    
    dispatch(getBrands());
    dispatch(getSizes());
    dispatch(getBrandModels());
   }, []);

 
  const imgState = useSelector((state) => state.upload.images);
   const brandState = useSelector((state) => state.brand.brands);
 const brandModelState = useSelector((state) => state.brandModel.brands);
 
  const sizeState = useSelector((state) => state.size.sizes);
 const location = useLocation();
  const productSlug = location.pathname.split("/")[3];
 

 
 const newProduct = useSelector((state) => state.product);
  
  const { 
    isSuccess,
     isError, 
     isLoading,
    createdProduct,
    updatedProduct,
   productData 
    } = newProduct;

 
  useEffect(() => {
    if (productSlug !== undefined) {
      dispatch(getAProduct(productSlug));
    } else {
      dispatch(resetState());
    }
  }, [productSlug]);

  const imgIsSuccess = useSelector((state) => state.upload.isSuccess);
const imgIsError = useSelector((state) => state.upload.isError);
const isUploading = useSelector((state) => state.upload.isLoading);

 
  useEffect(() => {
    if (imgIsSuccess && imgState.length > 0) {
      toast.success("Images uploaded successfully!", {
        autoClose: 4000,
      });
    }
  
    if (imgIsError) {
      toast.error("Image upload failed. Please try again.", {
        autoClose: 4000,
      });
    }
  }, [imgIsSuccess, imgIsError, imgState]);
  
useEffect(() => {
  if (isSuccess && createdProduct) {
    toast.success("Vehicle Added Successfully!", {
      autoClose: 2000, // Toast stays for 5 seconds before reload
    });
    setTimeout(() => {
      window.location.reload(); // Small delay to allow reset to complete
    }, 100); 
  }

  if (isSuccess && updatedProduct) {
    toast.success("Vehicle Updated Successfully!");
    window.location.href = "/admin/list-vehicle"; 
  }

  if (isError) {
    toast.error("Something Went Wrong!");
    setLoading(false);
      
  }
  
}, [isSuccess, isError, isLoading]);

 

 
  const img = [];
  imgState.forEach((i) => {
    img.push({
      public_id: i.public_id,
      url: i.url,
    });
  });


 

 
  const sizeopt = [];
sizeState.forEach((i) => {
  sizeopt.push({
    label: i.title,
    value: i._id,
  });
});

const handleImageDelete = (public_id) => {
  const updatedImages = formik.values.images.filter(
    (image) => image.public_id !== public_id
  );
  
  formik.setFieldValue("images", updatedImages);
};

useEffect(() => {
  if (productData) {
    formik.setValues((prevValues) => ({
      ...prevValues,
      images: imgState.length > 0 ? imgState : productData.images || [],
      engineSize:
        !formik.touched.engineSize // ✅ Prevent overwrite if user has interacted
          ? Array.isArray(productData.engineSize)
            ? productData.engineSize.map((size) =>
                typeof size === "object" && size._id ? size._id : size
              )
            : [productData.engineSize._id || productData.engineSize]
          : prevValues.engineSize, // ✅ Keep user selection if already changed
    }));
  }
}, [productData, imgState]);



useEffect(() => {
  if (imgState.length > 0) {
    formik.setFieldValue("images", imgState); // Update Formik values
  }
}, [imgState]); // Run effect when imgState updates

const formik = useFormik({
  enableReinitialize: true,
  initialValues: {
    title: productData?.title || "",
    description: productData?.description || "",
    type: productData?.type || "",
    brand: productData?.brand || "",
    brandModel: productData?.brandModel || "",
    yom: productData?.yom || "",
    price: productData?.price || "",
    transmission: productData?.transmission || "",
    location: productData?.location || "",
      engineSize: Array.isArray(productData?.engineSize)
        ? productData.engineSize.map((item) =>
            typeof item === "object" ? item._id : item
          )
        : productData?.engineSize
        ? [typeof productData.engineSize === "object"
            ? productData.engineSize._id
            : productData.engineSize]
        : [],


    availability: productData?.availability || "",
     tags: productData?.tags || "",
     usage: productData?.usage || "",
    drive: productData?.drive || "",
    mileageCategory: productData?.mileageCategory || "",
      horsePower: productData?.horsePower || "",
    acceleration: productData?.acceleration || "",
    fuelType: productData?.fuelType || "",
     images: productData?.images || [],
 
     market: productData?.market || "",
    seats: productData?.seats || "",
    seatsNumber: productData?.seatsNumber || "",
    engineDetail: productData?.engineDetail || "",
    torque: productData?.torque || "",
    driveTrain: productData?.driveTrain || "",
    rearSeats: productData?.rearSeats || "",
    upholstery: productData?.upholstery || "",
    cargoSpace: productData?.cargoSpace || "",
    frontSeats: productData?.frontSeats || "",
     steeringWheel: productData?.steeringWheel || "",
    climateControl: productData?.climateControl || "",
    fuelEfficiency: productData?.fuelEfficiency || "",
    towingCapacity: productData?.towingCapacity || "",
    groundClearance: productData?.groundClearance || "",
    interiorLighting: productData?.interiorLighting || "",
  },

  validationSchema: schema,

  onSubmit: async (values) => {
    console.log(values,"values")
    setLoading(true);

    // Format engineSize to store only ID
 
    // Override images with latest image state
    if (imgState.length > 0) {
      values.images = [...imgState];
    }

    if (productSlug !== undefined) {
      // Update product
      const data = { slug: productSlug, productData: values };
      dispatch(updateAProduct(data));
    } else {
      // Create product
      dispatch(createProducts(values));
      formik.resetForm({
        values: {
          ...formik.initialValues,
          images: [],
        },
      });
    }

    // Reset Redux state
    setTimeout(() => {
      dispatch(resetState());
    }, 3000);
  },
});

   
const handleSubmitbtn = async () => {
  // Validate the form
  const errors = await formik.validateForm();

if (Object.keys(errors).length > 0) {
  const missingFields = Object.keys(errors).join(", ");
  toast.error(`Please check: ${missingFields}`, {
    autoClose: 5000,
  });
  return;
}


  formik.handleSubmit(); // Submit form if no errors
};



const handleEngineSizeChange = (selectedSizes) => {
  

  // Ensure `selectedSizes` is always an array
  formik.setFieldValue("engineSize", Array.isArray(selectedSizes) ? selectedSizes : [selectedSizes]);
};


 console.log(productData,"product")

  return (
    <div>
      <h3 className="mb-4 title">
      {productSlug !== undefined ? "Edit" : "Add"} Car
      </h3>

      <div>
        <form
          onSubmit={formik.handleSubmit}
          className="d-flex gap-3 flex-column"
        >
          <CustomInput
            type="text"
            label="Enter Car Title"
            name="title"
            onChng={formik.handleChange("title")}
            onBlr={formik.handleBlur("title")}
            val={formik.values.title}
          />
          <div className="error">
            {formik.touched.title && formik.errors.title}
          </div>
          <div className="">
              <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-2">
                Description
              </label>
            <ReactQuill
              theme="snow"
              name="description"
              placeholder="Enter description"
              onChange={formik.handleChange("description")}
              value={formik.values.description}
            />
          </div>
          <div className="error">
            {formik.touched.description && formik.errors.description}
          </div>


      <CustomInput
        type="text"   
        label="Enter Price"
        name="price"
        val={Number(formik.values.price || 0).toLocaleString("en-US")}
        onChng={(e) => {
          const rawValue = e.target.value.replace(/,/g, "");  
          if (!isNaN(rawValue)) {
            formik.setFieldValue("price", rawValue);
          }
        }}
        onBlr={formik.handleBlur("price")}
        onKeyDown={(e) => {
          if (e.key === "-" || e.key === "e") {
            e.preventDefault();
          }
        }}
      />
      <div className="error">
        {formik.touched.price && formik.errors.price}
      </div>


<Select
  allowClear
  mode="multiple"
  className="w-100"
  placeholder="Select Engine size"
  value={formik.values.engineSize}
  onChange={handleEngineSizeChange}
>
  {[...sizeState]
    .sort((a, b) => {
      const getNumber = (val) => parseInt(val.title.replace(/\D/g, ""), 10);
      return getNumber(a) - getNumber(b);
    })
    .map((size) => (
      <Select.Option key={size._id} value={size._id}>
        {size.title}
      </Select.Option>
    ))}
</Select>
    

 <div className="table-grid">

<div className="input-cell">
          <select
            name="type"
            onChange={formik.handleChange("type")}
            onBlur={formik.handleBlur("type")}
            value={formik.values.type}
            className="form-control py-3 mb-3"
            id=""
          >
            <option value="" disabled>
              Select Body Type
            </option>
            <option value="SUV">SUV</option>
            <option value="Pickup">Pickup</option>
             <option value="Sedan">Saloon/Sedan</option>
            <option value="Hatchback">Hatchback</option>
            <option value="Van">Van</option>
            <option value="Wagon">Wagon</option>
          </select>
          <div className="error">
            {formik.touched.type && formik.errors.type}
          </div>
</div>

 
<div className="input-cell">
          <select
            name="brand"
            onChange={formik.handleChange("brand")}
            onBlur={formik.handleBlur("brand")}
            value={formik.values.brand}
            className="form-control py-3 mb-3"
            id=""
          >
            <option value="">Select Brand</option>
            {brandState
            .slice() // Create a copy to avoid mutating the original state
          .sort((a, b) => a.title.localeCompare(b.title)) // Sort alphabetically by title
           .map((i, j) => {
              return (
                <option key={j} value={i.title}>
                  {i.title}
                </option>
              );
            })}
          </select>
          <div className="error">
            {formik.touched.brand && formik.errors.brand}
          </div>
</div>

<div className="input-cell">
          <select
            name="brandModel"
            onChange={formik.handleChange("brandModel")}
            onBlur={formik.handleBlur("brandModel")}
            value={formik.values.brandModel}
            className="form-control py-3 mb-3"
          >
        <option value="">Select Brand Model</option>
        {brandModelState
          .slice() // Create a copy to avoid mutating the original state
          .sort((a, b) => a.title.localeCompare(b.title)) // Sort alphabetically by title
          .map((i, j) => (
            <option key={j} value={i.title}>
              {i.title}
            </option>
          ))}
        </select>
        <div className="error">
          {formik.touched.brandModel && formik.errors.brandModel}
        </div>
</div>

       


<div className="input-cell">
        <select
        name="yom"
        onChange={formik.handleChange("yom")}
        onBlur={formik.handleBlur("yom")}
        value={formik.values.yom}
        className="form-control py-3 mb-3"
        id=""
      >
        <option value="" disabled>
          Year of Manufacture
        </option>
        {[...Array(new Date().getFullYear() - 2004)]
      .map((_, index) => new Date().getFullYear() - index) // Start from current year
      .map((year) => (
        <option key={year} value={year}>{year}</option>
      ))}
  
      </select>
      <div className="error">
        {formik.touched.yom && formik.errors.yom}
      </div>
 </div>     

<div className="input-cell">
      <select
            name="transmission"
       
            onChange={formik.handleChange("transmission")}
            onBlur={formik.handleBlur("transmission")}
            value={formik.values.transmission}
            className="form-control py-3 mb-3"
            id=""
          >
            <option value="" disabled>
              Select Transmission
            </option>
          <option value="Automatic">Automatic</option>
          <option value="Manual">Manual</option>
           <option value="Manual & Automatic">Manual & Automatic</option>
         
          <option value="DCT">DCT</option>
          <option value="CVT">CVT</option>    
          </select>
          <div className="error">
            {formik.touched.transmission && formik.errors.transmission}
          </div>
</div>

<div className="input-cell">
          <select
            name="tags"
       
            onChange={formik.handleChange("tags")}
            onBlur={formik.handleBlur("tags")}
            value={formik.values.tags}
            className="form-control py-3 mb-3"
            id=""
          >
            <option value="" disabled>
              Select Tags
            </option>
          <option value="featured">Featured</option>
            <option value="popular">Popular</option>
            <option value="New Arrivals">New Arrivals</option>
  

          </select>
          <div className="error">
            {formik.touched.tags && formik.errors.tags}
          </div>
</div>

<div className="input-cell">
          <select
            name="location"
            onChange={formik.handleChange("location")}
            onBlur={formik.handleBlur("location")}
            value={formik.values.location}
            className="form-control py-3 mb-3"
            id=""
          >
            <option value="" disabled>
              Location
            </option>
             <option value="Mombasa">Mombasa</option>
           
            <option value="Nairobi">Nairobi</option>
          <option value="Singapore">Singapore</option>
          <option value="Japan">Japan</option>
          <option value="Uk">Uk</option>

          </select>
          <div className="error">
            {formik.touched.location && formik.errors.location}
          </div>
</div>
   
<div className="input-cell">
          <select
            name="drive"
            onChange={formik.handleChange("drive")}
            onBlur={formik.handleBlur("drive")}
            value={formik.values.drive}
            className="form-control py-3 mb-3"
            id=""
          >
            <option value="" disabled>
              Drive
            </option>
          <option value="AWD">AWD</option>
            
          <option value="4WD">4WD</option>
              <option value="FWD">FWD</option>
              <option value="RWD">RWD</option>
          </select>
          <div className="error">
            {formik.touched.drive && formik.errors.drive}
          </div>
</div>
<div className="input-cell">
          <select
            name="fuelType"
            onChange={formik.handleChange("fuelType")}
            onBlur={formik.handleBlur("fuelType")}
            value={formik.values.fuelType}
            className="form-control py-3 mb-3"
            id=""
          >
            <option value="" disabled>
             Fuel Type
            </option>
            <option value="Petrol">Petrol</option>
          <option value="Diesel">Diesel</option>
          <option value=" Hybrid (Petrol + Electric)"> Hybrid (Petrol + Electric)</option>
         
          </select>
          <div className="error">
            {formik.touched.fuelType && formik.errors.fuelType}
          </div>
</div>
<div className="input-cell">
          <CustomInput
            type="number"
            label="Enter  Horse Power"
            name="horsePower"
            onChng={formik.handleChange("horsePower")}
            onBlr={formik.handleBlur("horsePower")}
            val={formik.values.horsePower}
          />
          <div className="error">
            {formik.touched.horsePower && formik.errors.horsePower}
          </div>   
</div>
<div className="input-cell">
          <CustomInput
            type="number"
            label="Enter  Acceleration"
            name="acceleration"
            onChng={formik.handleChange("acceleration")}
            onBlr={formik.handleBlur("acceleration")}
            val={formik.values.acceleration}
          />
          <div className="error">
            {formik.touched.acceleration && formik.errors.acceleration}
          </div>
</div>

<div className="input-cell">
        <CustomInput
          type="text"
          label="Torque"
          name="torque"
          onChng={formik.handleChange("torque")}
          onBlr={formik.handleBlur("torque")}
          val={formik.values.torque}
        />
        <div className="error">{formik.touched.torque && formik.errors.torque}</div>
</div>

<div className="input-cell">
        <CustomInput
          type="text"
          label="Engine Detail"
          name="engineDetail"
          onChng={formik.handleChange("engineDetail")}
          onBlr={formik.handleBlur("engineDetail")}
          val={formik.values.engineDetail}
        />
        <div className="error">{formik.touched.engineDetail && formik.errors.engineDetail}</div>
</div>


  <div className="input-cell">
    <CustomInput
      type="text"
      label="Drive Train"
      name="driveTrain"
      onChng={formik.handleChange("driveTrain")}
      onBlr={formik.handleBlur("driveTrain")}
      val={formik.values.driveTrain}
    />
    <div className="error">{formik.touched.driveTrain && formik.errors.driveTrain}</div>
  </div>

<div className="input-cell">
  <select
    name="mileageCategory"
    onChange={formik.handleChange("mileageCategory")}
    onBlur={formik.handleBlur("mileageCategory")}
    value={formik.values.mileageCategory}
    className="form-control py-3 mb-3"
  >
    <option value="" disabled>
      Select Mileage Category
    </option>
<option value="Below 25000">Below 25,000 km</option>
<option value="Below 50000">Below 50,000 km</option>
<option value="Low">Low (Below 100,000 km)</option>
<option value="Medium">Medium (100,000 - 200,000 km)</option>
<option value="High">High (Above 200,000 km)</option>	
  </select>
  <div className="error">
    {formik.touched.mileageCategory && formik.errors.mileageCategory}
  </div>
</div>

  
 

 <div className="input-cell">
        <CustomInput
          type="text"
          label="Fuel Efficiency"
          name="fuelEfficiency"
          onChng={formik.handleChange("fuelEfficiency")}
          onBlr={formik.handleBlur("fuelEfficiency")}
          val={formik.values.fuelEfficiency}
        />
        <div className="error">{formik.touched.fuelEfficiency && formik.errors.fuelEfficiency}</div>
</div>     

 
 

<div className="input-cell">
        <CustomInput
          type="text"
          label="Towing Capacity"
          name="towingCapacity"
          onChng={formik.handleChange("towingCapacity")}
          onBlr={formik.handleBlur("towingCapacity")}
          val={formik.values.towingCapacity}
        />
        <div className="error">{formik.touched.towingCapacity && formik.errors.towingCapacity}</div>
</div>
<div className="input-cell">
        <CustomInput
          type="text"
          label="Ground Clearance"
          name="groundClearance"
          onChng={formik.handleChange("groundClearance")}
          onBlr={formik.handleBlur("groundClearance")}
          val={formik.values.groundClearance}
        />
        <div className="error">{formik.touched.groundClearance && formik.errors.groundClearance}</div>
</div>
 

<div className="input-cell">
  <div className="form-floating">
    <select
      id="availability"
      name="availability"
      onChange={formik.handleChange("availability")}
      onBlur={formik.handleBlur("availability")}
      value={formik.values.availability}
      className="form-control"
    >
      <option value="" disabled>
        Select Availability
      </option>
      <option value="Available">Available</option>
      <option value="Out of Stock">Out of Stock</option>
    </select>
    <label htmlFor="availability">Availability</label>
  </div>
  <div className="error">
    {formik.touched.availability && formik.errors.availability}
  </div>
</div>




<div className="input-cell">
  <div className="form-floating">
    <select
      id="market"
      name="market"
      onChange={formik.handleChange("market")}
      onBlur={formik.handleBlur("market")}
      value={formik.values.market}
      className="form-control"
    >
      <option value="" disabled>
        Select Market
      </option>
      <option value="Enroute">Enroute</option>
      <option value="Local">Local</option>
      <option value="Overseas">Overseas</option>
    </select>
    <label htmlFor="market">Market</label>
  </div>
  <div className="error">
    {formik.touched.market && formik.errors.market}
  </div>
</div>

<div className="input-cell">
        <CustomInput
          type="text"
          label="Seats Material"
          name="seats"
          onChng={formik.handleChange("seats")}
          onBlr={formik.handleBlur("seats")}
          val={formik.values.seats}
        />
        <div className="error">{formik.touched.seats && formik.errors.seats}</div>

</div>

<div className="input-cell">
        <CustomInput
          type="text"
          label="Seats Number"
          name="seatsNumber"
          onChng={formik.handleChange("seatsNumber")}
          onBlr={formik.handleBlur("seatsNumber")}
          val={formik.values.seatsNumber}
        />
        <div className="error">{formik.touched.seatsNumber && formik.errors.seatsNumber}</div>
</div>


    <div className="input-cell">
    <CustomInput
      type="text"
      label="Front Seats"
      name="frontSeats"
      onChng={formik.handleChange("frontSeats")}
      onBlr={formik.handleBlur("frontSeats")}
      val={formik.values.frontSeats}
    />
    <div className="error">{formik.touched.frontSeats && formik.errors.frontSeats}</div>
  </div>

  <div className="input-cell">
    <CustomInput
      type="text"
      label="Rear Seats"
      name="rearSeats"
      onChng={formik.handleChange("rearSeats")}
      onBlr={formik.handleBlur("rearSeats")}
      val={formik.values.rearSeats}
    />
    <div className="error">{formik.touched.rearSeats && formik.errors.rearSeats}</div>
  </div>

  <div className="input-cell">
    <CustomInput
      type="text"
      label="Upholstery"
      name="upholstery"
      onChng={formik.handleChange("upholstery")}
      onBlr={formik.handleBlur("upholstery")}
      val={formik.values.upholstery}
    />
    <div className="error">{formik.touched.upholstery && formik.errors.upholstery}</div>
  </div>

  <div className="input-cell">
    <CustomInput
      type="text"
      label="Cargo Space"
      name="cargoSpace"
      onChng={formik.handleChange("cargoSpace")}
      onBlr={formik.handleBlur("cargoSpace")}
      val={formik.values.cargoSpace}
    />
    <div className="error">{formik.touched.cargoSpace && formik.errors.cargoSpace}</div>
  </div>

 <div className="input-cell">
        <CustomInput
          type="text"
          label="Steering Wheel"
          name="steeringWheel"
          onChng={formik.handleChange("steeringWheel")}
          onBlr={formik.handleBlur("steeringWheel")}
          val={formik.values.steeringWheel}
        />
        <div className="error">{formik.touched.steeringWheel && formik.errors.steeringWheel}</div>
</div>
 <div className="input-cell">
        <CustomInput
          type="text"
          label="Climate Control"
          name="climateControl"
          onChng={formik.handleChange("climateControl")}
          onBlr={formik.handleBlur("climateControl")}
          val={formik.values.climateControl}
        />
        <div className="error">{formik.touched.climateControl && formik.errors.climateControl}</div>
</div>

<div className="input-cell">
        <CustomInput
          type="text"
          label="Interior Lighting"
          name="interiorLighting"
          onChng={formik.handleChange("interiorLighting")}
          onBlr={formik.handleBlur("interiorLighting")}
          val={formik.values.interiorLighting}
        />
        <div className="error">{formik.touched.interiorLighting && formik.errors.interiorLighting}</div>
</div>

 
</div>


      
 

        <div className="bg-white border-1 p-5 text-center">
      {/* File Drop Area */}
      <Dropzone
        onDrop={(acceptedFiles) => {
          const imageFiles = acceptedFiles.filter((file) =>
            file.type.startsWith("image/")
          );

          if (imageFiles.length > 0) {
            dispatch(uploadImg(imageFiles)); // Dispatch image upload
          }
        }}
      >
        {({ getRootProps, getInputProps }) => (
          <section>
            <div {...getRootProps()} className="dropzone">
              <input {...getInputProps()} />
              <p>Drag 'n' drop some files here, or click to select files</p>
            </div>
          </section>
        )}
      </Dropzone>
      </div>
      {/* Upload Progress Bar */}
     

      {/* Uploaded Images */}
      <div
        className={`showimages d-flex flex-wrap gap-3 ${
          isUploading ? "loading-border " : ""
        }`}
      >
        {formik.values.images &&
          formik.values.images.map((image, index) => (
            <div className="image-card position-relative" key={index}>
              <button
                type="button"
                onClick={() => handleImageDelete(image.public_id)}
                className="btn-close position-absolute"
                style={{ top: "10px", right: "10px" }}
              ></button>
              <img src={image.url} alt="" width="100%" height={200} />
            </div>
          ))}
      </div>




        
<button
        className="btn btn-success border-0 rounded-3 my-5"
        type="submit"
        disabled={loading} 
        onClick={handleSubmitbtn}// Disable button while loading
      >
        {loading ? (
          <>
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            Processing...
          </>
        ) : productSlug !== undefined ? (
          "Edit Vehicle"
        ) : (
          "Add Vehicle"
        )}
      </button>
        </form>
      </div>
    </div>
  );
};

export default Addproduct;
